import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, FormsModule, Validators} from '@angular/forms';
import {ChangeEvent, CKEditorModule} from '@ckeditor/ckeditor5-angular';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {SitePublicService} from 'src/app/services/site-public.service';
import {FirebaseUploadAdapter} from 'src/app/shared/adapters/firebase-upload-adapter';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {Subscription} from 'rxjs';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {FileManagerService} from '../../../shared/file-manager/file-manager.service';


@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: [ './history.component.scss' ]
})
export class HistoryComponent implements OnInit, OnDestroy {

  public entityForm: FormGroup;
  public Editor = ClassicEditor;
  public editorData = '';
  public editorConfig: any;

  public htmlContent: string = "";
  private formSubscription: Subscription | undefined;

  constructor (
    private _sitePublicService: SitePublicService,
    private fs: AngularFireStorage,
    private fb: FormBuilder,
    private _snackBar: SnackBarIconService,
  ) {  }

  ngOnInit (): void {
    this.configEditor()

    this._sitePublicService.getHistory("history_2025")
      .subscribe((result) => {
        this.htmlContent = result

        this.entityForm = this.createForm(this.htmlContent)

        this.formSubscription = this.entityForm.controls.text.valueChanges.subscribe(value => {
          this.htmlContent = value;
        });

      })
  }

  configEditor () {
    // 1. Configuração do Editor (Toolbar e Plugins)
    this.editorConfig = {
      // Toolbar: O que o usuário verá no menu
      toolbar: {
        items: [
          'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',

          'alignment', '|',

          'indent', 'outdent', '|', 'imageUpload', 'blockQuote', 'insertTable', 'undo', 'redo'
        ]
      },
      alignment: {
        // Define quais opções de alinhamento estarão disponíveis no dropdown
        options: [ 'left', 'right', 'center', 'justify' ]
      },
      // Configuração para o plugin de Link (já habilitado pela toolbar)
      link: {
        decorators: {
          addTargetToExternalLinks: true, // Adiciona target="_blank" para links externos
          defaultProtocol: 'https://'
        }
      },
      // Configuração para imagens (opcional, mas bom para restringir tipos)
      image: {
        toolbar: [
          'imageTextAlternative', 'imageStyle:full', 'imageStyle:side'
        ]
      },
      // Remove a necessidade de ter o CKEditor Cloud Service ou um adaptador padrão
      removePlugins: [ 'Base64UploadAdapter' ]
    };
  }

  ngOnDestroy () {
    // Importante: Desinscreva-se para evitar vazamento de memória
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  // 2. Ativa o Adaptador de Upload Personalizado
  public onReady (editor: any) {
    // Adiciona o plugin de upload personalizado (Classe FirebaseUploadAdapter)
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      // CORREÇÃO: Retorna uma NOVA INSTÂNCIA da CLASSE Adaptadora
      return new FirebaseUploadAdapter(loader, this.fs, 'site_pub/history/');
    };

    // Agora esta mensagem deve aparecer:
    console.log("CKEditor pronto e adaptador de upload do Firebase ativado.");
  }

  public onChange ({editor}: ChangeEvent) {
    this.editorData = editor.getData();
    // console.log(this.editorData);
  }
  createForm (data: any) {

    const form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      position: new FormControl(data.position, [ Validators.required ]),
      date: new FormControl(data.date?.toDate() || null, [ Validators.required ]),
      title: new FormControl(data.title, [ Validators.required ]),
      text: new FormControl(data.text, [ Validators.required ])
    });

    this.htmlContent = data.text;

    return form
  }

  saveData () {
    const formData = this.entityForm.getRawValue();
    const entity = {
      "id": 'history_2025',
      "position": 1,
      "date": new Date(),
      "title": 'Nossa História',
      "text": formData.text
    }

    console.log(JSON.stringify(entity));

    this._sitePublicService.setHistory(entity)
      .then(() => {
        this._snackBar.openSnackBar("Sucesso", '', 'success');
      })
      .catch((err) => {
        this._snackBar.openSnackBar("Erro", '', 'error');
      })
  }

}
